import { memo } from "react";
import { Link } from "react-router-dom";
import { modalities } from "../data/modalities";
import { services } from "../data/services";

const quickLinks = [
  { label: "Home", to: "/", isHash: false },
  { label: "About", to: "/#about", isHash: true },
  { label: "Services", to: "/#services", isHash: true },
  { label: "Contact", to: "/contact", isHash: false },
];

const phoneNumber = "90062 36133";
const phoneHref = "tel:9006236133";
const whatsappHref = "https://wa.me/919006236133";
const addressLines = [
  "Sonchafa Commercial, Kasturi Chowk,",
  "Office No 7, 2nd Floor,",
  "Dange Chowk Rd, Wakad, Pune, Maharashtra 411057",
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-rose-100 bg-rose-50">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 xl:grid-cols-4">
          <div className="space-y-6">
            <Link to="/" className="inline-flex items-center">
              <img
                src="/assets/logo-24-night-spa.png"
                alt="24 Night Spa Pune"
                width="180"
                height="46"
                loading="lazy"
                decoding="async"
                className="h-11 w-auto object-contain"
              />
            </Link>

            <p className="max-w-sm text-sm leading-7 text-zinc-600">
              Premium doorstep spa experiences crafted for comfort, privacy,
              and relaxation across Wakad, Hinjewadi, and Pune.
            </p>
          </div>

          <div className="xl:col-span-2">
            <h3 className="mb-5 font-label text-sm uppercase tracking-[0.28em] text-rose-500">
              Services & Modalities
            </h3>

            <div className="grid gap-8 sm:grid-cols-2">
              <div>
                <p className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-zinc-500">
                  Services
                </p>
                <ul className="space-y-3">
                  {services.map((service) => (
                    <li key={service.id}>
                      <Link
                        to={`/service/${service.slug}`}
                        className="text-sm leading-6 text-zinc-600 transition-colors hover:text-rose-500"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <p className="mb-4 text-xs font-semibold uppercase tracking-[0.24em] text-zinc-500">
                  Modalities
                </p>
                <ul className="space-y-3">
                  {modalities.map((modality) => (
                    <li key={modality.id}>
                      <Link
                        to={`/modality/${modality.slug}`}
                        className="text-sm leading-6 text-zinc-600 transition-colors hover:text-rose-500"
                      >
                        {modality.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="space-y-10">
            <div>
              <h3 className="mb-5 font-label text-sm uppercase tracking-[0.28em] text-rose-500">
                Quick Links
              </h3>
              <ul className="space-y-3">
                {quickLinks.map((item) => (
                  <li key={item.label}>
                    {item.isHash ? (
                      <a
                        href={item.to}
                        className="text-sm leading-6 text-zinc-600 transition-colors hover:text-rose-500"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.to}
                        className="text-sm leading-6 text-zinc-600 transition-colors hover:text-rose-500"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="mb-5 font-label text-sm uppercase tracking-[0.28em] text-rose-500">
                Contact Info
              </h3>

              <div className="space-y-4 text-sm leading-7 text-zinc-600">
                <p>{addressLines.join(" ")}</p>
                <p>
                  <a
                    href={phoneHref}
                    className="transition-colors hover:text-rose-500"
                  >
                    {phoneNumber}
                  </a>
                </p>
                <p>
                  <a
                    href={whatsappHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-rose-500"
                  >
                    WhatsApp
                  </a>
                </p>
                <p>Open 24 hours</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-rose-100">
        <div className="mx-auto flex max-w-7xl items-center justify-center px-6 py-5 text-center lg:px-8">
          <p className="text-xs uppercase tracking-[0.24em] text-zinc-500">
            Copyright {currentYear} 24 Night Spa. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default memo(Footer);
